import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Actions
import { ReferenceEdit } from '../../../../actions/orders'

// Utils
import { translation } from '../../../../utils/helpers'

// Elements
import Textarea from '../../../elements/textarea'
import Button from '../../../elements/button'
import { ReferenceIcons } from '../../../elements/icons'
import Panel from '../../../elements/panel'

class ReferenceActions extends Component {
  constructor (props) {
    super(props)

    this.state = {
      comment: ''
    }

    this.referenceEdit = this.referenceEdit.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
  }

  componentDidMount () {
    if (this.props.setBottomBarProps) {
      if (this.props.isApproval) {
        this.props.setBottomBarProps(this.renderApprovalButtons(true))
      } else if (this.props.isCancellation) {
        this.props.setBottomBarProps(this.renderCancellationButton(true))
      }
    }
  }

  referenceEdit (state) {
    let data = {
      orderReferralId: this.props.referenceInfo.OrderReferralId,
      state: state,
      comment: this.state.comment
    }

    return this.props.ReferenceEdit(data)
  }

  handleReferenceError (err) {
    // Toastr
    if (err.response !== undefined && err.response.data !== undefined) {
      window.toastr.error(translation(err.response.data.DictionaryKey), translation('216'))
    } else {
      window.toastr.error(translation('960'), translation('216'))
    }
  }

  onInputChange (e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  renderApprovalButtons (asProps = false) {
    const onclickApprove = (e) => {
      e.preventDefault()

      this.referenceEdit(1).then(res => {
        // window.toastr.success(translation('2257'), translation('13424'))
        this.props.onClose(true)
      }).catch(this.handleReferenceError)
    }

    const onclickReject = (e) => {
      e.preventDefault()

      this.referenceEdit(2).then(res => {
        window.toastr.info(translation('735'), translation('13424'))
        this.props.onClose()
      }).catch(this.handleReferenceError)
    }

    if (asProps) {
      return {
        actionLabelText: translation('15223'),
        onActionClick: onclickApprove,
        cancelStyle: 'alert',
        cancelLabelText: translation('15224'),
        onCancelClick: onclickReject,
        center: true
      }
    }

    return [
      <Button onClick={onclickApprove} labelText={translation('15223')} key='approve' />,
      <Button onClick={onclickReject} labelText={translation('15224')} style='alert' key='reject' />
    ]
  }

  renderCancellationButton (asProps = false) {
    const onclickCancel = (e) => {
      e.preventDefault()

      this.referenceEdit(4).then(res => {
        // window.toastr.success(translation('2021'), translation('13424'))
        this.props.onClose()
      }).catch(this.handleReferenceError)
    }

    if (asProps) {
      return {
        actionStyle: 'alert',
        actionLabelText: translation('15225'),
        onActionClick: onclickCancel,
        cancelLabelText: false
      }
    }

    return (
      <Button onClick={onclickCancel} labelText={translation('15225')} style='alert' />
    )
  }

  render () {
    const { department } = this.props

    let title
    let icon
    switch (department) {
      default:
      case 0:
        title = translation('149')
        icon = ReferenceIcons.Comment
        break
      case 1:
        title = translation('17881')
        break
    }

    return (
      <Panel title={title} icon={icon}>
        <Textarea
          name='comment'
          value={this.state.comment || ''}
          onChange={this.onInputChange}
        />

        {!this.props.setBottomBarProps && (
          <div className='refOrderApproval__buttons'>
            {this.props.isApproval && this.renderApprovalButtons()}
            {this.props.isCancellation && this.renderCancellationButton()}
          </div>
        )}
      </Panel>
    )
  }
}

ReferenceActions.propTypes = {
  referenceInfo: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
  }
}

export default connect(mapStateToProps, {
  ReferenceEdit
})(ReferenceActions)



// WEBPACK FOOTER //
// ./src/app/shared/modals/ReferenceOrderActionModal/ReferenceActions/index.js